import Calculator from './../util/Calculator';

export default {
  init() {
    // JavaScript to be fired on all pages

  // Init the calculator section
  var gold_price = $('.gold-price-calculator .amount').text().replace(',00 €','').replace('.','');
  var calculator = new Calculator({'gold': gold_price, 'gold_rachat': parseInt( $('#price-calculator-ref').text() )});

  function showResult(){

    var gold_price_raw = $('.gold-price-update').text();
    var gold_raw = gold_price_raw.substr(0, gold_price_raw.length - 3);
    gold_raw = gold_raw.replace('.','');

    var result = calculator.launch( $('#calculator-form input[name="action"]:checked').val(), $('#calculator-amout').val().replace(',','.'), $('input[name="gold_precision"]:checked').val(), gold_raw );
    $('#calculator-result').text( result.toFixed(2).replace('.', ','));
    $('.calculator-block-result').addClass('showed');
  }


  $('#calculator-form .calculator-submit').click(function(){
    showResult();


    return false;
  });

  $('#calculator-form').submit(function(){
    showResult();

    return false;
  });


  // Toggle
  $('#calculator-form input[name="action"]').change(function(){
    $('.calculator-block-result').removeClass('showed');
    $('#calculator-amout').val('');

    if( $( this ).val() == 'buy'){
      $('#calculator-form').removeClass('sell-mode').addClass('buy-mode');
    }else{
      $('#calculator-form').removeClass('buy-mode').addClass('sell-mode');
    }
  });


  // Change value
  $('#calculator-form input[name="gold_precision"]').change(function(){
    if( $('#calculator-amout').val() != '' ){
      showResult();
    }else{
      $('.calculator-block-result').removeClass('showed');
    }
  });


    // Add scrolled page on navbar
    var nav = $('.navbar.fixed-top');
    var navbar_timeout;
    var timeout_status = false;

    $(document).scroll(function () {

      if( $(window).scrollTop() > 0 ){

        if( timeout_status == false){
          timeout_status = true;

          navbar_timeout = setTimeout(function(){
            nav.addClass('navbar-scrolled'); // Detect if window is already scrolled
            timeout_status = false;
          }, 300);
        }

      }else{
        timeout_status = false;
        clearTimeout( navbar_timeout );
        nav.removeClass('navbar-scrolled');
      }

    });


    // Popover
    $(function () {
      $('[data-toggle="popover"]').popover({
        trigger: 'focus',
      });
    });


    /**
     * Init smooth scroll to anchor
     */
    $('#menu-menu-principal .nav-link, .smooth-scroll, #mobile-nav .nav-link').click(function(){

      if( $(this).attr('href').substr(0, 2) == '/#' || $(this).attr('href').substr(0, 1) == '#'){

        var selection = $(this).attr('href').substr(0, 1) == '#' ? $(this).attr('href') : $(this).attr('href').substr(1);

        if( $( selection ).length > 0 ){

          $(window).scrollTo($( selection ), 1200,{
            axis: 'y',
            offset: -80,
            onAfter: function(){
              $('#mobile-nav').width('0');
            },
          });

          return false;

        }
      }
    });

    // Launch pop-up
    /*setTimeout(function() {
      $('#rachat-tv').modal();
    },3000); // 1000 = 1s

    $('#rachat-tv').on('hidden.bs.modal', function () {
      $('#rachat-tv').remove(); // prevent video
    })*/

    $('iframe').load(function(){$(this).height($(this).contents().outerHeight());});

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    var delay = 15;
    var fadeOutDuration = 700;
    var fadeInDuration = 350;

    setInterval(function(){

      getAjaxPrice();
      getProductsPrice();

    }, delay*1000);


    /**
     * Update the gold price where it's displayed (element with 'gold-price-update' class)
     */
    function getAjaxPrice(){

      $.ajax({
        type:       'GET',
        dataType:   'json',
        url:        '/app/plugins/update-gold-price/gold-price.php',
        data: {
          ajax: 'true',
          'action': 'get',
          'type': 'gold',
        },
        success: function(data){

          $('.gold-price-update').fadeTo(fadeOutDuration, 0, function(){
            $( this ).html( data.price ).fadeTo(fadeInDuration, 1);
          });

        },
      });

    }

    /**
     * Update the products price where it's displayed (element with 'product-price-update' class)
     */
    function getProductsPrice(){

      $.ajax({
        type:       'GET',
        dataType:   'json',
        url:        '/app/plugins/update-gold-price/gold-price.php',
        data: {
          ajax: 'true',
          'action': 'get',
          'type': 'products',
        },
        success: function(data){

          $('.product-price-update').each(function(){
            var product_id = $(this).data('product');


            $( this ).fadeTo(fadeOutDuration, 0, function(){
              $( this).html( data['products'][ product_id ]).fadeTo(fadeInDuration, 1);
            });
          });

        },
      });

    }


    /**
     * Open mobile nav
     */
    $('#open-mobile-nav').click(function(){
      $('#mobile-nav').width('100%');
    });

    $('#mobile-nav .close-nav').click(function(){
      $('#mobile-nav').width('0');
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js